import { httpDelete, httpPostForm, httpPut } from '../../../api/httpClient';

export type ProductImageContext = 'cover' | 'image';
export interface ProductImageUpload {
  file: File;
  context: ProductImageContext;
  idempotencyKey: string;
  linkId?: number;
  revision?: number;
}
interface ImageUploadResult {
  status: string;
  requires_upload: boolean;
  error: string | null;
  file_id: number | null;
}

export const productMediaApi = {
  async upload(productId: number, request: ProductImageUpload): Promise<void> {
    const form = new FormData();
    form.append('file', request.file);
    form.append('context_code', request.context);
    form.append('idempotency_key', request.idempotencyKey);
    if (request.linkId !== undefined) form.append('link_id', String(request.linkId));
    if (request.revision !== undefined) form.append('revision', String(request.revision));
    const result = await httpPostForm<ImageUploadResult>(`/v1/catalog-product/${productId}/images`, form);
    if (result.status !== 'done' || result.file_id === null) {
      throw new Error(result.error || 'Фотография ещё загружается. Повторите попытку с тем же файлом.');
    }
  },
  reorder(productId: number, linkIds: number[], expectedLinkIds: number[]): Promise<void> {
    return httpPut(`/v1/catalog-product/${productId}/images/order`, { link_ids: linkIds, expected_link_ids: expectedLinkIds });
  },
  remove(productId: number, context: ProductImageContext, linkId: number): Promise<void> {
    return httpDelete(`/v1/catalog-product/${productId}/images/${context}/${linkId}`);
  },
};
